
(function () {
  function getSectionFromRoot(root) {
    return root.closest('[id^="shopify-section-"]');
  }

  function openInformationTab(section) {
    const xt = section.querySelector('x-tabs.product-information-tabs');
    if (xt) {
      xt.setAttribute('selected-index', '0');
    }
  }

  function openMobileOuterInformation(section) {
    const wrap = section.querySelector('[data-product-information-tabs-mobile-wrap]');
    if (!wrap) return;
    const first = wrap.querySelector('accordion-disclosure');
    if (!first || typeof first.open !== 'function') return;
    const det = first.disclosureElement;
    if (det && !det.open) {
      first.open({ instant: true });
    }
  }

  function closeAccordion(ad) {
    if (!ad || typeof ad.close !== 'function') return;
    const det = ad.querySelector('details');
    if (det && det.open) {
      ad.close();
    }
  }

  function openAccordion(ad) {
    if (!ad || typeof ad.open !== 'function') return;
    const det = ad.querySelector('details');
    if (det && !det.open) {
      ad.open({ instant: true });
    }
  }

  function syncInfoMedia(root) {
    var mediaColumn = root.querySelector('[data-info-media-column]');
    if (!mediaColumn) return;

    var items = mediaColumn.querySelectorAll('[data-info-media-key]');
    if (items.length === 0) return;

    var openWrapper = root.querySelector('.product-information-tabs__sub-accordion accordion-disclosure details[open]');
    var activeKey = null;

    if (openWrapper) {
      var subAccordion = openWrapper.closest('.product-information-tabs__sub-accordion');
      if (subAccordion) {
        activeKey = subAccordion.getAttribute('data-dropdown-key');
      }
    }

    var matched = false;
    items.forEach(function (item) {
      if (item.getAttribute('data-info-media-key') === activeKey) {
        item.hidden = false;
        matched = true;
      } else {
        item.hidden = true;
      }
    });

    if (!matched) {
      items[0].hidden = false;
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isValidSubAccordionEl(el) {
    if (!el || el.nodeType !== 1) return false;
    if (!el.classList.contains('product-information-tabs__sub-accordion')) return false;
    var id = el.id || '';
    if (!id || id.indexOf('product-tab-') !== 0) return false;
    return !!el.closest('[data-product-information-tabs-root]');
  }

  /**
   * @param {Element} el — .product-information-tabs__sub-accordion with id product-tab-*
   * @returns {boolean}
   */
  function activateInformationTarget(el) {
    if (!isValidSubAccordionEl(el)) return false;

    var root = el.closest('[data-product-information-tabs-root]');
    if (!root) return false;

    var section = getSectionFromRoot(root);
    if (!section) return false;

    openInformationTab(section);
    openMobileOuterInformation(section);

    var targetAd = el.querySelector('accordion-disclosure');
    if (!targetAd) return false;

    var disclosures = root.querySelectorAll('accordion-disclosure');
    disclosures.forEach(function (disclosure) {
      if (disclosure !== targetAd) closeAccordion(disclosure);
    });
    openAccordion(targetAd);
    syncInfoMedia(root);

    var scrollBehavior = prefersReducedMotion() ? 'auto' : 'smooth';
    window.setTimeout(function () {
      el.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
    }, 120);

    return true;
  }

  function resolveNavTargetElement(link) {
    var key = link.getAttribute('data-product-tab-key');
    if (key) {
      var byKey = document.querySelector(
        '[data-product-information-tabs-root] .product-information-tabs__sub-accordion[data-dropdown-key="' + key + '"]'
      );
      if (byKey) return byKey;
    }
    var sel = link.getAttribute('data-product-tab-nav-target') || link.getAttribute('href');
    if (!sel || sel.charAt(0) !== '#') return null;
    var id = sel.slice(1);
    if (!id || id.indexOf('product-tab-') !== 0) return null;
    return document.getElementById(id);
  }

  function setNavLinkActive(link) {
    var nav = link.closest('nav.product-info-tab-nav__links');
    if (!nav) return;
    nav.querySelectorAll('.product-info-tab-nav__link').forEach(function (a) {
      a.removeAttribute('aria-current');
      a.classList.remove('product-info-tab-nav__link--active');
    });
    link.setAttribute('aria-current', 'true');
    link.classList.add('product-info-tab-nav__link--active');
  }

  function handleHash() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    var id = hash.slice(1);
    if (!id || id.indexOf('product-tab-') !== 0) return;

    var el = document.getElementById(id);
    if (!el) return;

    activateInformationTarget(el);
  }

  function initExclusive(root) {
    var disclosures = root.querySelectorAll('accordion-disclosure');
    if (disclosures.length === 0) return;

    disclosures.forEach(function (ad) {
      var details = ad.querySelector('details');
      if (!details) return;
      details.addEventListener('toggle', function () {
        if (details.open && !(typeof Shopify !== 'undefined' && Shopify.designMode)) {
          disclosures.forEach(function (other) {
            if (other === ad) return;
            var od = other.querySelector('details');
            if (od && od.open) closeAccordion(other);
          });
        }
        syncInfoMedia(root);
      });
    });

    syncInfoMedia(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-information-tabs-root]').forEach(initExclusive);
    handleHash();
  });

  window.addEventListener('hashchange', handleHash);

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.product-info-tab-nav__link');
    if (!link) return;

    var el = resolveNavTargetElement(link);
    if (!el || !isValidSubAccordionEl(el)) return;

    e.preventDefault();

    if (activateInformationTarget(el)) {
      setNavLinkActive(link);
    }
  });
})();
